import PropTypes from "prop-types";

import {
  NOTIFICATION_TYPE_SINGLE,
  NOTIFICATION_TYPE_CRITICAL,
  NOTIFICATION_TYPE_INFO,
} from "Services/notification";

const notificationMessageShape = {
  type: PropTypes.oneOf([
    NOTIFICATION_TYPE_SINGLE,
    NOTIFICATION_TYPE_CRITICAL,
    NOTIFICATION_TYPE_INFO,
  ]),
  account_id: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  short_content: PropTypes.string.isRequired,
  read: PropTypes.bool.isRequired,
  date_from: PropTypes.string.isRequired,
  date_to: PropTypes.string,
};

export default notificationMessageShape;
